import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import { cn } from '@/shared/lib/cn';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | undefined;
  icon?: ReactNode;
  inputClassName?: string;
  ref?: Ref<HTMLInputElement>;
}

export const TextField = ({
  className,
  icon,
  label,
  onChange,
  inputClassName,
  ref,
  ...inputProps
}: TextFieldProps) => (
  <label className={cn('field', className)}>
    <span className="text-xs font-medium text-ink-subtle">{label}</span>
    {icon ? (
      <div className="field-input">
        <span className="field-icon">{icon}</span>
        <input
          className={inputClassName}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          ref={ref}
          {...inputProps}
        />
      </div>
    ) : (
      <input
        className={inputClassName}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        ref={ref}
        {...inputProps}
      />
    )}
  </label>
);
